'use strict';
var parent = require('../../es/set/symmetric-difference');

module.exports = parent;
